import BaseApi from "../../BaseApi";
import {headers} from "../../ApiSettings";

class Contract extends BaseApi {
    constructor() {
        super({suffix: ""});
    }
    GetAllContract(params) {
        return this.httpService.get("/Project/contract", {headers, params})
    }
    PostAllContract(data) {
        return this.httpService.post("/Project/contract", data, {
            headers,
        });
    }
    DeleteContract(data) {
        return this.httpService.delete("/Project/contract", { headers, data });
    }
    PostContractPrint(data) {
        return this.httpService.post("/Project/generate-html-contract", data, {
            headers,
        });
    }
}

const ContractService = new Contract();
export default ContractService;

